import { OpenFeature } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';

/**
 * Killswitch for rejoining a pipe-table row that generation split across real
 * newlines. OFF (default): such a row is stitched back into one line (interior
 * newlines become `<br>`, the serializer's own multi-line cell convention) so
 * the table forms. ON: break-glass — no line is ever joined, so a split row
 * falls through to paragraphs with visible `|` characters (legacy behaviour).
 *
 * Notes saved by the editor are unaffected either way: the save serializer
 * already emits one line per row, and a row that already ends with `|` is never
 * a rejoin candidate.
 *
 * `op-scribe-disable-table-roundtrip-fix` also disables the rejoin — it is the
 * break-glass for every table fix, so one flip reverts the whole parse.
 *
 * Called outside React (markdown helpers), so non-hook only. Lives in this
 * standalone `.ts` module (not the `index.tsx` barrel) so the reader does not
 * add a `react-refresh/only-export-components` warning to the component barrel.
 */
export const isTableRowRejoinKilled = () => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'op-scribe-disable-table-row-rejoin',
    false
  );
};
